import { useState } from "react";
import { CampoNumero, Resultado, Dato, Rejilla } from "../components/campos.jsx";
import { calcularImc } from "../lib/calc.js";

const TONOS = {
  "Bajo peso": "aviso",
  "Peso normal": "positivo",
  Sobrepeso: "aviso",
  Obesidad: "alerta",
};

export default function Imc() {
  const [peso, setPeso] = useState(70);
  const [altura, setAltura] = useState(170);
  const r = calcularImc(peso, altura);

  return (
    <div className="space-y-6">
      <Rejilla>
        <div className="space-y-4">
          <CampoNumero label="Peso corporal" valor={peso} onChange={setPeso} sufijo="kg" min={0} />
          <CampoNumero label="Altura / estatura" valor={altura} onChange={setAltura} sufijo="cm" min={0} />
        </div>

        <div className="order-first space-y-3 lg:order-last lg:col-span-2">
          <Resultado
            label="Índice de Masa Corporal"
            valor={r.imc ? r.imc.toFixed(1) : "—"}
            nota={r.categoria}
            tono={TONOS[r.categoria] ?? "acento"}
          />
          {r.pesoIdeal && (
            <div className="tarjeta">
              <Dato
                label="Rango de peso saludable para tu estatura"
                valor={`${r.pesoIdeal.min.toFixed(1)} – ${r.pesoIdeal.max.toFixed(1)} kg`}
                destacar
              />
              <Dato label="Clasificación OMS" valor={r.categoria} />
            </div>
          )}
          <p className="text-2xs texto-3">
            El IMC es un indicador poblacional: no distingue entre músculo y grasa, ni considera edad,
            sexo o complexión. Un resultado fuera de rango es motivo para consultar a un profesional
            de salud, no un diagnóstico.
          </p>
        </div>
      </Rejilla>
    </div>
  );
}
